import React from 'react';

const HowItWorks = ({ onOpenModal }) => {
  const steps = [
    {
      number: '01',
      title: 'Tell Us About Your Property',
      description: 'Fill out our simple form or give us a call. No obligation, no pressure—just the facts about your home.',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
        </svg>
      )
    },
    {
      number: '02',
      title: 'Get a Fair Cash Offer',
      description: "We'll review your property details and present you with a competitive, no-hassle cash offer within 24 hours.",
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      )
    },
    {
      number: '03',
      title: 'Close On Your Terms',
      description: 'Pick your closing date. We can close in as little as 7 days or work around your schedule. You choose.',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
        </svg>
      )
    }
  ];

  return (
    <section id="how-it-works" className="py-20 bg-white">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-propwhiz-dark mb-4">
            How Our Simple 3-Step Process Works
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Selling your house for cash has never been easier. Just three simple steps to your cash offer.
          </p>
        </div>

        <div className="relative">
          {/* Connecting Line (hidden on mobile) */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-1 bg-gray-200 -translate-y-1/2"></div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 relative">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="bg-white rounded-2xl p-8 shadow-xl relative z-10">
                  <div className="bg-propwhiz-blue text-white w-16 h-16 rounded-2xl flex items-center justify-center mb-6 transform -rotate-6">
                    <span className="text-2xl font-bold">{step.number}</span>
                  </div>
                  <div className="text-propwhiz-blue mb-4">{step.icon}</div>
                  <h3 className="text-2xl font-bold text-propwhiz-dark mb-4">{step.title}</h3>
                  <p className="text-gray-600">{step.description}</p>
                </div>

                {/* Arrow for mobile/tablet */}
                {index < steps.length - 1 && (
                  <div className="lg:hidden flex justify-center my-4">
                    <svg className="w-8 h-8 text-propwhiz-blue" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                    </svg>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <button onClick={onOpenModal} className="btn-primary text-lg px-12 py-4">
            Start Your Process Now
          </button>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;